import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { ObjectNameEnum } from '@base/modules/rest/master-data-history/model/enums/object-name.enum';
import { TranslateService } from '@ngx-translate/core';
import { REPORT_PREFIX } from '@base/utils/common.util';

@Pipe({
  name: 'objectNameTranslate',
})
export class ObjectNameTranslatePipe implements PipeTransform {

  constructor(private translateService: TranslateService) {
  }

  transform(value: string | ObjectNameEnum): string {
    if (!value) {
      return '';
    }
    if (value.startsWith('DocumentBbs_')) {
      return value.replace('DocumentBbs_', '');
    }
    if (value.startsWith(REPORT_PREFIX)) {
      return value.replace(REPORT_PREFIX, '');
    }
    const res: string = this.translateService.instant(`OBJECT_NAME.${value}`);
    if (res.startsWith('OBJECT_NAME.')) {
      return value;
    }
    return res;
  }
}

@NgModule({
  exports: [
    ObjectNameTranslatePipe,
  ],
  declarations: [
    ObjectNameTranslatePipe,
  ],
})
export class ObjectNameTranslatePipeModule {
}
